import type { AbstractControl } from '@angular/forms';

export function inclusionValidator<K extends string | number>(values: K[]) {
  return function (control: AbstractControl<K>): { inclusion: true } | null {
    if (!control.value) return null;

    return values.includes(control.value) ? null : { inclusion: true };
  };
}
